import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['CollectionManager']['getBonusCollection']
type inputType = RouterInputs['CollectionManager']['getBonusCollection']

export const useGetBonusCollection = (input: inputType, options?: optionsType) =>
    api.CollectionManager.getBonusCollection.useQuery(input, {
        ...options,
        queryKey: ['CollectionManager.getBonusCollection', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
        refetchOnWindowFocus: false
    })
